export const ADMIN_CRM_PATH = "/admin/crm";
export const ADMIN_CRM_MAILING_LIST_PATH = "/admin/crm/mailing_list";
export const ADMIN_CRM_CONTACTS_PATH = "/admin/crm/contacts";
export const ADMIN_CRM_REFERRAL_PATH = "/admin/crm/referral";
export const ADMIN_CRM_FEEDBACK_PATH = "/admin/crm/feedback";
export const ADMIN_CRM_REVIEW_PATH = "/admin/crm/review";

export function adminCrmReferralEventPath(eventId) {
    return `${ADMIN_CRM_REFERRAL_PATH}/${encodeURIComponent(eventId)}`;
}

export function adminCrmReferralInvitersPath(eventId) {
    return `${ADMIN_CRM_REFERRAL_PATH}/${encodeURIComponent(eventId)}/inviters`;
}

export function adminCrmFeedbackDetailPath(feedbackId) {
    return `${ADMIN_CRM_FEEDBACK_PATH}/${encodeURIComponent(feedbackId)}`;
}
